var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('main',{staticClass:"container"},[(_vm.fall!=undefined)?_c('h2',{staticClass:"headline headline--fall",attrs:{"data-splitting":""}},[_vm._v(_vm._s(_vm.fall))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }